import { cartState } from "./cart-state";

/**
 * Header cart bubble.
 *
 * Always present in the DOM — the previous implementation only rendered the
 * badge when `cart.item_count > 0`, so there was nothing to update when the
 * cart emptied and the count froze at its last value.
 *
 * Hidden rather than shown as "0" when the cart is empty, matching the design
 * today. Remove `hide-when-empty` from the Liquid to show a literal 0 instead.
 */
class CartCount extends HTMLElement {
  private unsubscribe: (() => void) | null = null;

  connectedCallback(): void {
    cartState.init(Number(this.dataset.count ?? 0));

    this.unsubscribe = cartState.subscribe((state) => {
      this.textContent = String(state.count);
      this.setAttribute("aria-hidden", state.count === 0 ? "true" : "false");

      if (this.hasAttribute("hide-when-empty")) {
        this.toggleAttribute("hidden", state.count === 0);
      }
    });
  }

  disconnectedCallback(): void {
    this.unsubscribe?.();
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "cart-count": CartCount;
  }
}

if (!window.customElements.get("cart-count")) {
  window.customElements.define("cart-count", CartCount);
}

export {};
